import React, { useState, useEffect } from 'react';
import Footer from '../../Components/Footer/Footer';
import './About.css';
import HomeNav from '../../Components/Navbar/NewNavbar';
import Loading1 from '../../Components/Loading/Loading1';

function About() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 900);
    }, []);

    if (isLoading) {
        return <Loading1 />;
    }

    return (
        <>
            <HomeNav />
            <div className="about-container">
                <h2 className="about-title">About Us</h2>
                <p className="about-text">
                    Welcome to <strong>Astra Clean</strong>, where we believe that a clean environment is the foundation of a happy and healthy life.
                    We are a dedicated team of cleaning professionals committed to making your spaces shine, whether it's your home,
                    office, or any other place that needs a thorough and reliable cleaning service.
                </p>
                <p className="about-text">
                    At Astra Clean, we offer a wide range of cleaning services tailored to meet your specific needs. Our services include
                    <strong> residential cleaning</strong> to keep your home spotless, <strong>commercial cleaning</strong> to maintain a productive and welcoming workspace,
                    and specialized cleaning for those unique tasks that require extra care and attention. No matter the job, our experienced
                    staff is equipped with the tools and expertise to deliver exceptional results every time.
                </p>
                <p className="about-text">
                    We understand that life can be busy, so we make it easy for you to book our services through our website or official channels.
                    With flexible scheduling options and a variety of payment methods, including <strong>credit/debit cards, bank transfers, and digital
                    wallets</strong>, we ensure that your experience with Astra Clean is as convenient as possible. While we don't offer cancellations due to
                    our quick 2-hour service response time, we do provide the option to reschedule your appointment, giving you the flexibility to
                    manage your time as needed.
                </p>
                <p className="about-text">
                    At Astra Clean, <strong>your satisfaction is our top priority.</strong> We are dedicated to providing high-quality service, and if for any reason
                    you're not completely satisfied with our work, we encourage you to contact us within 24 hours. We will do everything we can to
                    make it right and ensure that you are happy with the results.
                </p>
                <p className="about-text">
                    Your trust in us means everything, and we are committed to building long-lasting relationships with our customers. We take pride
                    in our work and strive to exceed your expectations with every service. Whether it's a one-time deep clean or regular maintenance,
                    you can count on Astra Clean to keep your environment clean, fresh, and inviting.
                </p>
                <p className="about-text">
                    Thank you for choosing <strong>Astra Clean</strong>. We look forward to serving you and helping you create a cleaner, more comfortable space.
                </p>
            </div>
            <Footer />
        </>
    );
}

export default About;
